export const internationalTranslations = {
  de: {
    country: 'Land',
    allCountries: 'Alle Länder',
    legalForm: 'Rechtsform',
    noResults: 'Keine passenden Einträge gefunden.',
    searchError: 'Vorschläge konnten nicht geladen werden.',
    legacyValue: 'Bestehender Wert außerhalb des Katalogs. Bitte prüfen.',
    remove: '{{name}} entfernen',
    otherLegalForm: 'Andere Rechtsform',
    otherName: 'Bezeichnung der anderen Rechtsform',
    otherRequired: 'Bitte die andere Rechtsform bezeichnen.',
    invalidLegalForm: 'Bitte eine Rechtsform aus dem Katalog wählen.',
    legalMismatch:
      'Diese Rechtsform passt nicht zum gewählten Rechtsgebiet oder ist nicht mehr aktiv. Bestehender Wert bleibt erhalten; bitte prüfen.',
    noCoverage:
      'Für dieses Rechtsgebiet enthält der Katalog keine aktiven Rechtsformen. Verwenden Sie „Andere Rechtsform“.',
    jurisdiction: 'Abweichendes Rechtsgebiet / Niederlassung',
    seatJurisdiction: 'Rechtsgebiet des Sitzlandes',
    jurisdictionHint:
      'Nur bei Bedarf abweichend wählen. Die Lieferadresse hat keinen Einfluss auf die Rechtsform.',
  },
  en: {
    country: 'Country',
    allCountries: 'All countries',
    legalForm: 'Legal form',
    noResults: 'No matching entries found.',
    searchError: 'Suggestions could not be loaded.',
    legacyValue: 'Existing value outside the catalogue. Please review.',
    remove: 'Remove {{name}}',
    otherLegalForm: 'Other legal form',
    otherName: 'Name of the other legal form',
    otherRequired: 'Please name the other legal form.',
    invalidLegalForm: 'Please select a legal form from the catalogue.',
    legalMismatch:
      'This legal form does not match the selected jurisdiction or is inactive. The existing value is retained; please review.',
    noCoverage:
      'The catalogue has no active legal forms for this jurisdiction. Use “Other legal form”.',
    jurisdiction: 'Different jurisdiction / branch',
    seatJurisdiction: 'Jurisdiction of the registered country',
    jurisdictionHint:
      'Select a different jurisdiction only when needed. Shipping addresses do not determine legal forms.',
  },
  fr: {
    country: 'Pays',
    allCountries: 'Tous les pays',
    legalForm: 'Forme juridique',
    noResults: 'Aucune entrée correspondante.',
    searchError: 'Impossible de charger les suggestions.',
    legacyValue: 'Valeur existante hors catalogue. Veuillez la vérifier.',
    remove: 'Retirer {{name}}',
    otherLegalForm: 'Autre forme juridique',
    otherName: 'Dénomination de l’autre forme juridique',
    otherRequired: 'Veuillez préciser l’autre forme juridique.',
    invalidLegalForm: 'Veuillez choisir une forme juridique du catalogue.',
    legalMismatch:
      'Cette forme juridique ne correspond pas à la juridiction choisie ou est inactive. La valeur existante est conservée ; veuillez la vérifier.',
    noCoverage:
      'Le catalogue ne contient aucune forme juridique active pour cette juridiction. Utilisez « Autre forme juridique ».',
    jurisdiction: 'Autre juridiction / succursale',
    seatJurisdiction: 'Juridiction du pays du siège',
    jurisdictionHint:
      'Choisissez une autre juridiction si nécessaire. L’adresse de livraison ne détermine pas la forme juridique.',
  },
  es: {
    country: 'País',
    allCountries: 'Todos los países',
    legalForm: 'Forma jurídica',
    noResults: 'No se encontraron entradas coincidentes.',
    searchError: 'No se pudieron cargar las sugerencias.',
    legacyValue: 'Valor existente fuera del catálogo. Revíselo.',
    remove: 'Quitar {{name}}',
    otherLegalForm: 'Otra forma jurídica',
    otherName: 'Nombre de la otra forma jurídica',
    otherRequired: 'Indique la otra forma jurídica.',
    invalidLegalForm: 'Seleccione una forma jurídica del catálogo.',
    legalMismatch:
      'Esta forma jurídica no corresponde a la jurisdicción seleccionada o está inactiva. Se conserva el valor existente; revíselo.',
    noCoverage:
      'El catálogo no contiene formas jurídicas activas para esta jurisdicción. Use «Otra forma jurídica».',
    jurisdiction: 'Otra jurisdicción / sucursal',
    seatJurisdiction: 'Jurisdicción del país de la sede',
    jurisdictionHint:
      'Seleccione otra jurisdicción solo si es necesario. La dirección de entrega no determina la forma jurídica.',
  },
  tr: {
    country: 'Ülke',
    allCountries: 'Tüm ülkeler',
    legalForm: 'Hukuki biçim',
    noResults: 'Eşleşen kayıt bulunamadı.',
    searchError: 'Öneriler yüklenemedi.',
    legacyValue: 'Katalog dışında mevcut değer. Lütfen kontrol edin.',
    remove: '{{name}} değerini kaldır',
    otherLegalForm: 'Diğer hukuki biçim',
    otherName: 'Diğer hukuki biçimin adı',
    otherRequired: 'Lütfen diğer hukuki biçimi belirtin.',
    invalidLegalForm: 'Lütfen katalogdan bir hukuki biçim seçin.',
    legalMismatch:
      'Bu hukuki biçim seçilen yargı alanına uymuyor veya etkin değil. Mevcut değer korunur; lütfen kontrol edin.',
    noCoverage:
      'Katalog bu yargı alanı için etkin bir hukuki biçim içermiyor. “Diğer hukuki biçim” seçeneğini kullanın.',
    jurisdiction: 'Farklı yargı alanı / şube',
    seatJurisdiction: 'Merkez ülkesinin yargı alanı',
    jurisdictionHint:
      'Yalnızca gerektiğinde farklı bir alan seçin. Teslimat adresi hukuki biçimi belirlemez.',
  },
};
